import en from "./en";
import vi from "./vi";
import id from "./id";
import th from "./th";

const resource = { en, vi, id, th };

export default resource;
